/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const solutionProcessStepDtoSchema = z.object({
  step: z.optional(z.string()),
  input: z.optional(z.string()),
  systemAction: z.optional(z.string()),
  output: z.optional(z.string()),
  description: z.optional(z.string()),
});
